import React from "react";

interface RabbitAgentProps {
    size?: number;
    className?: string;
}

const RabbitAgent: React.FC<RabbitAgentProps> = ({ size = 20, className }) => {
    return (
        <svg
            fill="currentColor"
            width={size}
            height={size}
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g id="o">
                <path d="M12.04,32.18l-3.36,7.64c-.37,.85-.37,1.82,.02,2.66l7.33,16.01c.42,.91,1.34,1.5,2.34,1.5h17.6c.57,0,1.09-.34,1.31-.87,.22-.53,.11-1.13-.28-1.55l-3.68-3.85,6.6-6.31,3.89,1.2c.93,.29,1.91-.24,2.19-1.17,.05-.16,.07-.33,.07-.49l.11-13.94,6.07-2.74c.83-.38,1.48-1.08,1.79-1.94l1.42-3.93c.37-1.02-.12-2.17-1.11-2.62l-20.4-9.18-6.06-7.94c-.27-.36-.59-.58-.93-.65h0c-.35-.07-.71,.02-.98,.25-.33,.28-.48,.7-.46,1.25l.75,20.25-12.34,4.6c-.85,.32-1.55,.98-1.92,1.81Zm22.6,25.82h-11.61l8.61-3.14,3,3.14Zm9.51-18.88l-4.51-3.14,4.54-2.05-.04,5.2Zm-.59,2.03l-4.59,4.42h0l-4.91,4.7,4.11-12.88,5.39,3.76Zm-1.98,4.69l2.54-2.45-.02,3.22-2.52-.77Zm12.01-22.1l-1.42,3.93c-.13,.35-.39,.64-.73,.79l-13.63,6.15-9.28-8.4,5.28-11.47,19.73,8.88s.07,.07,.05,.11Zm-21.43-10.18l-4,8.68-.54-14.64,4.54,5.96Zm-5.06,14.06l9.39,8.49-5.37,16.83-13.17,4.8s-.07-.02-.09-.06l-7.33-16.01c-.15-.33-.15-.7,0-1.03l3.36-7.64c.15-.34,.44-.61,.79-.74l12.44-4.64Z" />
            </g>
        </svg>
    );
};

export default RabbitAgent;
